// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DCdt","top":"styles_top__1te-T"};